import { Platform } from 'react-native';

import { theme } from '@garnish/constants';

export const NAVBAR_CONTENT_HEIGHT = 56;
export const NAVBAR_FLOATING_ACTION_SIZE = 60;
export const NAVBAR_BASE_CONTAINER_HEIGHT =
  NAVBAR_CONTENT_HEIGHT +
  Platform.select({ web: theme.spacing['10'], default: theme.spacing['6'] });
export const NAVBAR_BASE_CONTAINER_HEIGHT_SM = NAVBAR_FLOATING_ACTION_SIZE + theme.spacing['4'] * 2;
export const NAVBAR_MENU_ANIMATION_DURATION = 320;
